module.exports = __webpack_public_path__ + "static/media/bronzeImg.7346c82a.png";